var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2858 5.78305C11.349 5.78305 12.6816 5.07104 13.4753 4.12168C14.194 3.26133 14.7181 2.05981 14.7181 0.858281C14.7181 0.695111 14.7031 0.53194 14.6732 0.398438C13.4902 0.442938 12.0677 1.18462 11.2142 2.17848C10.5404 2.93499 9.92643 4.12168 9.92643 5.33804C9.92643 5.51605 9.95638 5.69405 9.97135 5.75339C10.0462 5.76822 10.166 5.78305 10.2858 5.78305ZM6.54232 23.7318C7.99479 23.7318 8.63867 22.7676 10.4505 22.7676C12.2923 22.7676 12.6966 23.7021 14.3138 23.7021C15.901 23.7021 16.9642 22.2484 17.9674 20.8244C19.0905 19.1927 19.5547 17.5906 19.5846 17.5165C19.4798 17.4868 16.4401 16.2556 16.4401 12.7994C16.4401 9.80297 18.8359 8.45311 18.9707 8.34927C17.3835 6.09456 14.9727 6.03522 14.3138 6.03522C12.5319 6.03522 11.0794 7.10325 10.166 7.10325C9.17773 7.10325 7.875 6.09456 6.33268 6.09456C3.39779 6.09456 0.417969 8.49761 0.417969 13.0367C0.417969 15.8551 1.52604 18.8367 2.88867 20.765C4.05664 22.3967 5.07487 23.7318 6.54232 23.7318Z",
    fill: "#000100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleicon);
export default __webpack_public_path__ + "static/media/appleicon.e015eec5f00a8d623fbb623456bf9bcd.svg";
export { ForwardRef as ReactComponent };